<template>
<div class="user">
    <div class="photo">
        <img :src="usuario.image" alt="avatar" />
    </div>
    <div class="user-info">
        <a data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" @click.capture="clicked">
            <span>
                {{ usuario.apelido }}
                <b class="caret"></b>
            </span>
        </a>

        <collapse-transition>
            <div v-show="!isClosed" class="perfil-usuario">
                <ul class="nav">
                    <slot>
                        <li>
                            <a @click="usuarioCadastrar()">
                                <span class="sidebar-mini">PU</span>
                                <span class="sidebar-normal">PERFIL</span>
                            </a>
                        </li>
                    </slot>
                </ul>
            </div>
        </collapse-transition>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            isClosed: true,
            usuario: {
                apelido: this.$store.state.usuario.apelido.toUpperCase(),
                image: "./img/usuario/0.jpg"
            }
        };
    },
    methods: {
        clicked: function (e) {
            e.preventDefault();
        },
        toggleMenu: function () {
            this.isClosed = !this.isClosed;
        },
        usuarioCadastrar() {
            if (this.$route.name !== 'usuarioUpdatePerfil') {
                this.$router.push({
                    name: 'usuarioUpdatePerfil',
                    params: {
                        id: this.$store.state.usuario.id
                    }
                })
            }
        }
    }
};
</script>

<style>
.collapsed {
    transition: opacity 1s;
}

.user-info {
    margin-top: -10px !important;
    margin-bottom: -10px !important;
}

.perfil-usuario {
    margin-top: -10px !important;
    margin-bottom: -10px !important;
}
</style>
